import { mount } from "svelte";
import IndexPage from "./IndexPage.svelte";
import QuizPage from "./QuizPage.svelte";

function mountComponent() {
  const json = document.getElementById("props").textContent;
  const props = JSON.parse(json);

  let target = document.getElementById("index-page");
  if (target) {
    mount(IndexPage, { target, props });
    return;
  }

  target = document.getElementById("quiz-page");
  if (target) {
    mount(QuizPage, { target, props });
    return;
  }

  throw new Error(`Could not find element to mount with Svelte`);
}

mountComponent();
